import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COUNTRY_CODES } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  BaseBackResponse,
  WorkType,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}worktype`;

interface UpsertWorkTypeCommandPayload {
  id?: string;
  uniqueName: string;
  label: string;
  averageDuration: number;
  nbTechniciansRequired: number;
  sellerId: string;
  localeList: {
    cultureCode: COUNTRY_CODES;
    label: string;
    key: string;
  }[];
  complexityCoefficient: number;
}

const upsertWorkTypeCommand = async (
  payload: UpsertWorkTypeCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<WorkType>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default upsertWorkTypeCommand;
